var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 234.304,
    height: 234.029,
    viewBox: "0 0 234.304 234.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.258,
    y1: 0.258,
    x2: 0.864,
    y2: 0.864,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.576,
    y1: 1.051,
    x2: 0.396,
    y2: -0.246,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.621,
    y1: 0.621,
    x2: 0.063,
    y2: 0.063,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.624,
    y1: 0.573,
    x2: -0.617,
    y2: 0.109,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.332,
    y1: 0.127,
    x2: 2.44,
    y2: 1.418,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.861,
    y1: 1.207,
    x2: -0.583,
    y2: -0.071,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.581,
    y1: 0.581,
    x2: 2.07,
    y2: 1.774,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.627,
    y1: 0.637,
    x2: 0.182,
    y2: 0.116,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.251,
    y1: 0.449,
    x2: 1.416,
    y2: 0.585,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.406,
    y1: 0.485,
    x2: 2.192,
    y2: 1.126,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.313,
    y1: 0.313,
    x2: 0.96,
    y2: 0.961,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.56,
    y1: 0.56,
    x2: 0.018,
    y2: 0.018,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.49,
    y1: 0.674,
    x2: 1.216,
    y2: -0.675,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.019,
    y1: 0.5,
    x2: 0.986,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.613,
    y1: 0.518,
    x2: 1.521,
    y2: 0.473,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9edf5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1.947,
    y1: 1.005,
    x2: -0.223,
    y2: -0.151,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#c8b7e0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8f81b8",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.313,
    y1: 0.313,
    x2: 0.961,
    y2: 0.961,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.56,
    y1: 0.56,
    x2: 0.018,
    y2: 0.018,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.49,
    y1: 0.674,
    x2: 1.216,
    y2: -0.675,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.569,
    y1: 0.528,
    x2: 1.295,
    y2: -0.821,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_003-worldwide",
    "data-name": "003-worldwide",
    transform: "translate(-0.045)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 117,
    cy: 117,
    r: 117,
    transform: "translate(0.349)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M199.46,55.521a116.032,116.032,0,0,0-12.734-8.111,116.042,116.042,0,0,0-8.112-12.735C162.236,12.378,140.377.1,117.067.1S71.9,12.378,55.521,34.675a116,116,0,0,0-8.112,12.735,116.084,116.084,0,0,0-12.735,8.112C12.378,71.9.1,93.758.1,117.068s12.28,45.168,34.577,61.547a116,116,0,0,0,12.735,8.112,116.084,116.084,0,0,0,8.112,12.735c16.379,22.3,38.237,34.577,61.547,34.577s45.168-12.28,61.547-34.577a116,116,0,0,0,8.112-12.735,116.1,116.1,0,0,0,12.734-8.111c22.3-16.379,34.577-38.237,34.577-61.547S221.757,71.9,199.46,55.521ZM117.067,228.53c-6.424,0-13.233-9.569-18.615-25.9a159.532,159.532,0,0,0,37.231,0C130.3,218.961,123.491,228.53,117.067,228.53Zm0-30.314a152.263,152.263,0,0,1-20.381-1.364c-3.668-12.971-6.332-28.541-7.856-45.541,9.125.653,18.592.988,28.236.988s19.111-.336,28.236-.988c-1.524,17-4.187,32.569-7.856,45.541a152.255,152.255,0,0,1-20.381,1.364Zm0-192.612c6.424,0,13.233,9.569,18.616,25.9a159.532,159.532,0,0,0-37.231,0c5.383-16.328,12.192-25.9,18.615-25.9Zm0,30.314a152.257,152.257,0,0,1,20.381,1.364c3.668,12.971,6.332,28.541,7.856,45.541-9.125-.653-18.592-.988-28.236-.988s-19.111.336-28.236.988c1.524-17,4.187-32.57,7.856-45.541a152.262,152.262,0,0,1,20.381-1.364ZM87.341,117.068c0-9.818.354-19.439,1.036-28.69,9.251-.682,18.872-1.036,28.69-1.036s19.44.354,28.69,1.036c.682,9.251,1.036,18.872,1.036,28.69s-.354,19.439-1.036,28.69c-9.251.682-18.872,1.036-28.69,1.036s-19.439-.354-28.69-1.036C87.7,136.507,87.341,126.886,87.341,117.068ZM82.824,145.3c-17-1.524-32.57-4.187-45.541-7.856a152.917,152.917,0,0,1,0-40.761c12.971-3.668,28.541-6.332,45.541-7.856-.653,9.125-.988,18.592-.988,28.236S82.171,136.179,82.824,145.3Zm68.488-56.473c17,1.524,32.569,4.187,45.541,7.856a152.918,152.918,0,0,1,0,40.761c-12.971,3.668-28.541,6.332-45.541,7.856.653-9.125.988-18.592.988-28.236S151.964,97.956,151.312,88.831Zm-.441-5.566a267.424,267.424,0,0,0-7.457-45.05,133.251,133.251,0,0,1,39.23,13.277,133.252,133.252,0,0,1,13.277,39.23A267.424,267.424,0,0,0,150.87,83.265Zm-67.606,0a267.424,267.424,0,0,0-45.05,7.457,133.248,133.248,0,0,1,13.277-39.23,133.252,133.252,0,0,1,39.23-13.277A267.536,267.536,0,0,0,83.265,83.265ZM31.5,135.683C15.174,130.3,5.6,123.491,5.6,117.068s9.569-13.233,25.9-18.615a159.528,159.528,0,0,0,0,37.231ZM83.265,150.87a267.425,267.425,0,0,0,7.457,45.05,133.247,133.247,0,0,1-39.23-13.277,133.251,133.251,0,0,1-13.277-39.23A267.5,267.5,0,0,0,83.265,150.87Zm67.606,0a267.425,267.425,0,0,0,45.05-7.457,133.251,133.251,0,0,1-13.277,39.23,133.251,133.251,0,0,1-39.23,13.277,267.423,267.423,0,0,0,7.457-45.05Zm51.763-52.418c16.328,5.383,25.9,12.192,25.9,18.615s-9.569,13.232-25.9,18.615a159.528,159.528,0,0,0,0-37.231Zm24.6,6.215c-5.388-4.594-13.928-8.725-25.428-12.259a141.635,141.635,0,0,0-10.509-35.823c18.827,12.259,31.921,29.094,35.937,48.081ZM177.55,42.842a141.633,141.633,0,0,0-35.823-10.509c-3.534-11.5-7.664-20.041-12.259-25.428,18.988,4.016,35.822,17.11,48.082,35.937ZM104.667,6.9c-4.594,5.388-8.725,13.929-12.259,25.428A141.634,141.634,0,0,0,56.585,42.842C68.845,24.015,85.679,10.921,104.667,6.9ZM42.842,56.585A141.635,141.635,0,0,0,32.333,92.408c-11.5,3.534-20.041,7.664-25.428,12.259C10.921,85.679,24.015,68.845,42.842,56.585ZM6.9,129.468c5.388,4.594,13.929,8.725,25.428,12.259A141.635,141.635,0,0,0,42.842,177.55C24.015,165.29,10.921,148.456,6.9,129.468Zm49.68,61.825A141.634,141.634,0,0,0,92.408,201.8c3.534,11.5,7.664,20.041,12.259,25.428C85.679,223.214,68.845,210.12,56.585,191.293Zm72.883,35.937c4.595-5.388,8.725-13.929,12.259-25.428a141.632,141.632,0,0,0,35.823-10.509c-12.259,18.827-29.094,31.921-48.082,35.937Zm61.825-49.681A141.629,141.629,0,0,0,201.8,141.727c11.5-3.534,20.04-7.664,25.428-12.259C223.214,148.456,210.12,165.29,191.293,177.55Z",
    transform: "translate(-0.053 -0.053)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 104.45,
    cy: 104.45,
    rx: 104.45,
    ry: 104.45,
    transform: "translate(12.564 12.564)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M307.843,280.606,207.112,179.875a16.013,16.013,0,1,0-22.531,22.509c.707.874,7.8,7.917,8.156,8.282v6.125a9.1,9.1,0,0,0-3.214,16.417l80.5,80.5a117.58,117.58,0,0,0,37.82-33.1Z",
    transform: "translate(-96.669 -94.118)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M182.424,251.893l4.53,4.53a8.835,8.835,0,0,1,2.588,6.247,8.835,8.835,0,0,0,8.835,8.835,9.214,9.214,0,0,1,9.214,9.213,47.558,47.558,0,0,1-4.053,19.213l-16.31,36.934a7.864,7.864,0,0,1-12.755,2.384,30.374,30.374,0,0,1-8.9-21.477v-4.3a42.23,42.23,0,0,0-12.369-29.861l-.483-.483a39.74,39.74,0,0,1-11.64-28.1v-1.54a13.238,13.238,0,0,1,13.238-13.238,39.742,39.742,0,0,1,28.1,11.64Z",
    transform: "translate(-76.344 -130.006)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M226.847,274.781a8.835,8.835,0,0,1-8.835-8.835,8.835,8.835,0,0,0-2.588-6.247l-4.53-4.53a39.721,39.721,0,0,0-13.535-8.862c1.749,1.756,3.357,3.355,3.523,3.524v6.125a9.1,9.1,0,0,0-3.214,16.417l33.265,33.265,1.073-2.431a47.566,47.566,0,0,0,4.053-19.213,9.213,9.213,0,0,0-9.213-9.214Z",
    transform: "translate(-104.815 -133.282)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M86.672,14.721A117.4,117.4,0,0,0,20.6,75.7a25.422,25.422,0,0,0-2.3,10.646,25.788,25.788,0,0,0,7.553,18.235l2.392,2.392a57.148,57.148,0,0,0,40.409,16.738,4.1,4.1,0,1,0,0-8.2h-12.6a10.524,10.524,0,0,1,0-21.049H65.9A44.5,44.5,0,0,0,97.363,81.431l15.2-15.2a17.647,17.647,0,0,1,12.478-5.169,17.647,17.647,0,0,0,15.89-9.97A11.252,11.252,0,0,0,130.8,34.947H111.188a10.439,10.439,0,0,1-10.439-10.439,10.451,10.451,0,0,0-14.077-9.787Z",
    transform: "translate(-9.902 -7.613)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M138.288,46.064H118.679a10.439,10.439,0,0,1-10.439-10.439c0-.343-.021-.678-.052-1.01A104.6,104.6,0,0,0,32.142,114.4c.386.443.783.879,1.2,1.3l2.392,2.392a57.148,57.148,0,0,0,40.409,16.738,4.1,4.1,0,0,0,0-8.2h-12.6a10.524,10.524,0,0,1,0-21.049h9.843a44.5,44.5,0,0,0,31.468-13.034l15.2-15.2a17.648,17.648,0,0,1,12.478-5.169,17.647,17.647,0,0,0,15.89-9.97,11.252,11.252,0,0,0-10.131-16.148Z",
    transform: "translate(-17.393 -18.73)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M423.668,185.243a16.075,16.075,0,0,0-15.729-12.563H382.626a27.136,27.136,0,0,0-27.136,27.136v3.3a23.834,23.834,0,0,0,23.835,23.834,12.119,12.119,0,0,1,12.119,12.119v31.646c0,8.247,10.708,11.532,15.29,4.676a116.317,116.317,0,0,0,18.506-48.441,118.306,118.306,0,0,0-1.572-41.709Z",
    transform: "translate(-192.363 -93.441)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M428.053,113.231H393.1a11.321,11.321,0,0,1,0-22.641h19.952a117,117,0,0,1,15,22.641Z",
    transform: "translate(-206.589 -49.02)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 9.108,
    cy: 9.108,
    rx: 9.108,
    ry: 9.108,
    transform: "translate(88.886 122.466)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 7.601,
    cy: 7.601,
    rx: 7.601,
    ry: 7.601,
    transform: "translate(90.392 123.972)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M208.016,268.974A9.111,9.111,0,0,1,195.794,281.2a9.109,9.109,0,1,0,12.222-12.222Z",
    transform: "translate(-105.948 -145.547)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M211.279,260.077a1.925,1.925,0,0,1-1.925-1.925V236.13h3.85v22.022A1.926,1.926,0,0,1,211.279,260.077Z",
    transform: "translate(-113.286 -127.775)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M213.323,259.976a1.925,1.925,0,0,0,1.317-1.825V236.129h-2.633v22.022A1.924,1.924,0,0,0,213.323,259.976Z",
    transform: "translate(-114.721 -127.774)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M209.354,239.506l3.85,3.85V236.13h-3.85Z",
    transform: "translate(-113.286 -127.775)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 16.016,
    cy: 16.016,
    rx: 16.016,
    ry: 16.016,
    transform: "translate(81.977 79.813)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 13.367,
    cy: 13.367,
    rx: 13.367,
    ry: 13.367,
    transform: "translate(84.627 82.463)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M203.819,177.611A16.021,16.021,0,0,1,182.327,199.1a16.018,16.018,0,1,0,21.492-21.492Z",
    transform: "translate(-98.661 -96.109)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M183.911,26.893A117.046,117.046,0,0,1,26.893,183.911,117.027,117.027,0,1,0,183.911,26.893Z",
    transform: "translate(-14.552 -14.552)",
    fill: "url(#linear-gradient-20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.3272eba27e073c170a6853f9cb713866.svg";
export { ForwardRef as ReactComponent };